module.exports = __webpack_public_path__ + "static/media/mrw.33369928.svg";